import { Button, Checkbox, Col, Form, Input, Row, Select, Switch } from "antd";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Header from "../../components/Layout/Header";
import { ImageUrl } from "../../config/helper";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert";
import { addUser } from "../../redux/slice/authSlice";
import { Post } from "../../config/api/post";
import { USER, USER_AUTH } from "../../config/constants/api";
import socket from "../../config/socket";
import { FaUserCircle } from "react-icons/fa";
import { ImUserPlus } from "react-icons/im";
import { FaArrowLeftLong } from "react-icons/fa6";

const SignIn = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [type, setType] = useState(null);
  const token = useSelector((state) => state.user.userToken);
  const location = useLocation();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (token) {
      navigate("/");
    }
  }, []);
  const onFinish = (values) => {
    setLoading(true);
    let data = {
      email: values.email,
      phone: "1" + values.phone,
    };
    if (type === "new") {
      data = {
        ...data,
        firstName: values.firstName,
        lastName: values.lastName,
      };
      Post(USER.guestSignup, data)
        .then((response) => {
          setLoading(false);
          if (response?.status) {
            swal("Success", response?.message, "success");
            navigate("/guestVerification", {
              state: { email: values.email, data: location?.state?.data },
            });
          }
        })
        .catch((err) => {
          let message = err?.response?.data?.message
            ? err?.response?.data?.message
            : err?.message;
          setLoading(false);
          console.log(":::;", err);
          if (message) swal("Oops!", message, "error");
        });
    } else if (type === "existing") {
      Post(USER.guestLogin, data)
        .then((response) => {
          setLoading(false);
          if (response?.status) {
            swal("Success", response?.message, "success");
            navigate("/guestVerification", {
              state: { email: values.email, data: location?.state?.data },
            });
          }
        })
        .catch((err) => {
          let message = err?.response?.data?.message
            ? err?.response?.data?.message
            : err?.message;
          setLoading(false);
          console.log(":::;", err);
          if (message) swal("Oops!", message, "error");
        });
    }
  };
  const onChange = (e) => {
    setChecked(e.target.checked);
  };
  return (
    <>
      <Header />
      <Row
        justify="center"
        style={{
          backgroundImage: `url('${ImageUrl("register-back.png")}')`, // Setting background color to black with 90% opacity
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
        className="flex items-center justify-center min-h-screen"
      >
        <Col
          lg={8}
          sm={20}
          xs={20}
          className="flex flex-col justify-center my-52 max-sm:my-32"
        >
          <div className="flex flex-col justify-center items-center bg-white rounded-lg py-8 px-8 max-lg:px-2 ">
            {type && (
              <FaArrowLeftLong
                className="arrow cursor-pointer"
                onClick={() => setType(null)}
                style={{ position: "absolute", top: "20px", left: "20px" }}
              />
            )}
            <h3 className="mt-4 font-tavi text-3xl text-black max-lg:text-2xl">
              Continue as a Guest
            </h3>
            <p className="capitalize font-euclid text-sm text-[#34324B] mb-8 max-lg:text-xs text-center">
              Enter your credentials to get a confirmation code
            </p>
            {!type ? (
              <div className="select-guset-box">
                <div
                  className="select-guset"
                  onClick={() => setType("existing")}
                >
                  <FaUserCircle />
                  <h6>i have an account</h6>
                </div>
                <div className="select-guset" onClick={() => setType("new")}>
                  <ImUserPlus />
                  <h6>i am a new guest</h6>
                </div>
              </div>
            ) : (
              <Form
                form={form}
                name="normal_login"
                onFinish={onFinish}
                layout="vertical"
                className="w-full px-2 max-xl:px-2"
              >
                {type === "new" && (
                  <Row justify="center" gutter={[16, 16]}>
                    <Col md={12} sm={24} xs={24}>
                      <Form.Item
                        name="firstName"
                        label={
                          <p className="font-euclid text-sm text-[#34324B] font-bold">
                            First Name
                          </p>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please input your first name!",
                          },
                        ]}
                      >
                        <Input
                          placeholder="First Name"
                          className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                          autoComplete={false}
                          type="text"
                        />
                      </Form.Item>
                    </Col>
                    <Col md={12} sm={24} xs={24}>
                      <Form.Item
                        name="lastName"
                        label={
                          <p className="font-euclid text-sm text-[#34324B] font-bold">
                            Last Name
                          </p>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please input your last name!",
                          },
                        ]}
                      >
                        <Input
                          placeholder="Last Name"
                          className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                          autoComplete={false}
                          type="text"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                )}
                <Row justify="center" gutter={[16, 16]}>
                  <Col md={type === "new" ? 12 : 24} sm={24} xs={24}>
                    <Form.Item
                      name="email"
                      label={
                        <p className="font-euclid text-sm text-[#34324B] font-bold">
                          Email Address
                        </p>
                      }
                      rules={[
                        {
                          required: true,
                          message: "Please input your email address!",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Email Address"
                        className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                        autoComplete={false}
                        type="email"
                      />
                    </Form.Item>
                  </Col>

                  <Col md={type === "new" ? 12 : 24} sm={24} xs={24}>
                    <p
                      className="font-euclid text-sm text-[#34324B] font-bold"
                      style={{ paddingBottom: "11px" }}
                    >
                      Phone Number
                    </p>
                    <div style={{ display: "flex" }}>
                      <Input.Group compact style={{ maxWidth: "50px" }}>
                        <Input
                          value="+1"
                          disabled
                          className="h-12 text-sm font-euclid bg-gray-200 w-14"
                        />
                      </Input.Group>
                      <Form.Item
                        className={`${type === "new" ? '' : 'w-full'}`}
                        name="phone"
                        rules={[
                          {
                            required: true,
                            message:
                              "Please enter your phone number (must be 10 digits long excluding +1)!",
                          },
                          {
                            validator: (_, value) => {
                              if (!value) {
                                return Promise.reject(
                                  "Please enter your phone number!"
                                );
                              }
                              if (!/^\d{10}$/.test(value)) {
                                return Promise.reject(
                                  "Phone number must be exactly 10 digits (excluding +1)!"
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <Input
                          type="number"
                          size="large"
                          placeholder="Enter Phone Number"
                          className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                          style={{
                            MozAppearance: "textfield",
                            maxWidth: "100%",
                          }}
                        />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>

                {/* {type === "new" && (
                  <Row justify="center">
                   
                  </Row>
                )} */}
                <Checkbox onChange={onChange} className="md:mx-4 mb-4">
                  <p className="text-xs text-black font-euclid max-xl:text-xs">
                    By checking this box "Yes," you agree to receive text
                    messages from us at the number you provided
                  </p>
                </Checkbox>

                <Row justify="center">
                  <Col md={12}>
                    <Form.Item className="self-center text-center mb-0">
                      <Button
                        htmlType="submit"
                        className={`${
                          !checked
                            ? "bg-gray-300 text-gray-500 cursor-not-allowed px-14 h-[50px]"
                            : "bg-button hover:bg-white hover:border-customGold hover:border-2 font-urban font-bold text-white px-14 h-[50px] hover:text-customGold text-center text-sm"
                        }`}
                        disabled={!checked}
                      >
                        {loading ? "LOADING..." : "Proceed"}
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>

                <Row justify="center">
                  <Link
                    to="/signIn"
                    className="font-euclid text-black text-sm  font-normal mt-4 hover:text-black max-xl:text-xs max-sm:text-[10px]"
                  >
                    Back to{" "}
                    <Link
                      to="/signIn"
                      className="font-semibold  border-b-2 border-black"
                    >
                      Login
                    </Link>
                  </Link>
                </Row>
              </Form>
            )}

            {/*  */}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default SignIn;
